import { render, staticRenderFns } from "./EventReactionsBar.vue?vue&type=template&id=f623eaa2&scoped=true"
import script from "./EventReactionsBar.vue?vue&type=script&lang=js"
export * from "./EventReactionsBar.vue?vue&type=script&lang=js"
import style0 from "./EventReactionsBar.vue?vue&type=style&index=0&id=f623eaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f623eaa2",
  null
  
)

export default component.exports